"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ScheduleCallModal } from "./schedule-call-modal";
import { useUser } from "@/context/user-context";

export function ScheduleCallButton({
  className,
  text,
  icon,
  reload
}:{
  className: string;
  text: string;
  icon?: React.ReactNode;
  reload?: () => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const { isAuthenticated } = useUser();

  return (
    <>
      <Button 
        onClick={() => {
          if (!isAuthenticated) {
            alert("Please log in to schedule a call.");
            return;
          }
          setIsOpen(true);
        }}
        size="lg"
        className={className}
      >
        {icon}
        {text}
      </Button>
      
      <ScheduleCallModal
        open={isOpen}
        onOpenChange={setIsOpen}
        reload={reload}
      />
    </>
  );
}